import { Button } from 'antd';
import { useWebReaderGalleyAccess } from '../hooks/useWebReaderGalleyAccess';
import { getReaderHref } from '../../util/getReaderHref';
import { TranslateType } from '@above-the-treeline/localization';

type IGhostButtonProps = {
	sku: string;
	translate: TranslateType;
};
export const GhostButton = ({ sku, translate }: IGhostButtonProps) => {
	const { isLoading, hasWebReaderGalleyAccess } = useWebReaderGalleyAccess();

	return (
		<Button
			type="ghost"
			target="_blank"
			loading={isLoading}
			disabled={!hasWebReaderGalleyAccess(sku)}
			href={getReaderHref(sku)}>
			{translate('read_online')}
		</Button>
	);
};
